/* ===== LOTUS PACKAGING — MAIN JS ===== */

// ===== HERO CAROUSEL =====
(function initCarousel() {
  const slides = document.querySelector('.hero-slides');
  const dots = document.querySelectorAll('.hero-dot');
  if (!slides || !dots.length) return;
  
  let current = 0;
  const total = dots.length;
  
  function goTo(i) {
    current = i;
    slides.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((d, idx) => d.classList.toggle('active', idx === current));
  }
  
  dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
  
  setInterval(() => goTo((current + 1) % total), 5000);
})();

// ===== MOBILE MENU =====
(function initMobileMenu() {
  const btn = document.querySelector('.mobile-menu-toggle');
  const nav = document.querySelector('.nav-list');
  if (!btn || !nav) return;
  
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = nav.classList.toggle('open');
    btn.setAttribute('aria-expanded', isOpen);
    // Toggle icons
    var openIcon = btn.querySelector('.menu-icon-open');
    var closeIcon = btn.querySelector('.menu-icon-close');
    var label = btn.querySelector('.menu-label');
    if (openIcon) openIcon.style.display = isOpen ? 'none' : 'block';
    if (closeIcon) closeIcon.style.display = isOpen ? 'block' : 'none';
    if (label) label.textContent = isOpen ? 'Close' : 'Menu';
  });
  
  // Close menu when clicking a nav link
  nav.querySelectorAll('.nav-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      // Don't close if it's the Products mega-menu toggle
      if (this.parentElement.classList.contains('has-mega') && window.innerWidth < 769) {
        e.preventDefault();
        this.parentElement.classList.toggle('active');
        return;
      }
      if (window.innerWidth < 769) {
        nav.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        var openIcon = btn.querySelector('.menu-icon-open');
        var closeIcon = btn.querySelector('.menu-icon-close');
        var label = btn.querySelector('.menu-label');
        if (openIcon) openIcon.style.display = 'block';
        if (closeIcon) closeIcon.style.display = 'none';
        if (label) label.textContent = 'Menu';
      }
    });
  });
})();

// ===== QUANTITY SELECTORS =====
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.qty-minus, .qty-plus');
  if (!btn) return;
  
  const container = btn.closest('.btn-qty, .pdp-qty');
  if (!container) return;
  
  const input = container.querySelector('input');
  let val = parseInt(input.value) || 1;
  
  if (btn.classList.contains('qty-minus')) {
    val = Math.max(1, val - 1);
  } else {
    val = Math.min(999, val + 1);
  }
  
  input.value = val;
  
  // Update PDP price display if on product page
  updatePDPPrice(val);
});

// ===== PDP PRICE UPDATE =====
function updatePDPPrice(qty) {
  const table = document.querySelector('.tier-pricing-table');
  if (!table) return;
  
  const rows = table.querySelectorAll('tbody tr');
  rows.forEach(row => {
    row.classList.remove('active-tier');
    const qtyCell = row.querySelector('.qty-cell');
    if (!qtyCell) return;
    
    const text = qtyCell.textContent.trim();
    let min = 0, max = Infinity;
    
    if (text.includes('+')) {
      min = parseInt(text);
    } else if (text.includes('-')) {
      const parts = text.split('-');
      min = parseInt(parts[0]);
      max = parseInt(parts[1]);
    } else {
      min = parseInt(text);
      max = min;
    }
    
    if (qty >= min && qty <= max) {
      row.classList.add('active-tier');
      row.style.background = '#e8f0fe';
    } else {
      row.style.background = '';
    }
  });
}

// ===== TABS =====
(function initTabs() {
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');
  if (!tabBtns.length) return;
  
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(target)?.classList.add('active');
    });
  });
})();

// ===== ADD TO CART ANIMATION =====
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.btn-add-cart, .pdp-add-btn');
  if (!btn) return;
  
  const original = btn.innerHTML;
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg> Added!';
  btn.style.background = '#27ae60';
  
  setTimeout(() => {
    btn.innerHTML = original;
    btn.style.background = '';
  }, 1500);
  
  // Update cart count
  const cartCount = document.querySelector('.cart-count');
  if (cartCount) {
    let count = parseInt(cartCount.textContent) || 0;
    cartCount.textContent = count + 1;
  }
});

// ===== FILTER TOGGLE =====
document.addEventListener('click', function(e) {
  const header = e.target.closest('.filter-group h4');
  if (!header) return;
  
  const group = header.closest('.filter-group');
  const options = group.querySelector('.filter-options');
  if (options) {
    options.style.display = options.style.display === 'none' ? 'block' : 'none';
    const svg = header.querySelector('svg');
    if (svg) svg.style.transform = options.style.display === 'none' ? 'rotate(-90deg)' : '';
  }
});

// ===== FORM HANDLING =====
document.addEventListener('submit', function(e) {
  if (e.target.matches('.contact-form form, .wholesale-form form')) {
    e.preventDefault();
    const btn = e.target.querySelector('button[type="submit"]');
    if (btn) {
      const original = btn.textContent;
      btn.textContent = 'Submitted Successfully!';
      btn.style.background = '#27ae60';
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = '';
        e.target.reset();
      }, 2000);
    }
  }
});

// ===== SMOOTH SCROLL =====
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// ===== SEARCH =====
// Search form submits naturally via form action


// Mega-menu toggle is now handled in the mobile menu handler above
